export enum IntegrationPointType {
    VENUE_EVENT_MAIN_STAGE = 'VENUE_EVENT_MAIN_STAGE',
    VENUE_SESSION_SIDE_PANEL = 'VENUE_SESSION_SIDE_PANEL',
    VENUE_EVENT_SIDE_PANEL = 'VENUE_EVENT_SIDE_PANEL',
    VENUE_EVENT_SIDE_PANEL_GAMIFICATION = 'VENUE_EVENT_SIDE_PANEL_GAMIFICATION',
}

export interface IAppExtensionItem {
    id: string;
    type: IntegrationPointType;
    integrationPoint: IntegrationPointType;
    contentUrl: string;
    isMobileSupport: boolean;
    clientId: string;
    category: string;
    name: string;
}

export type AppExtensionsResponse = {
    entities: IAppExtensionItem[];
    totalSize: number;
    offset: number;
};

// temporary mapping until data will be configurable on dashboard
export const IntegrationPointData = {
    VENUE_SESSION_SIDE_PANEL: {
        label: 'Session Interaction',
        icon: 'https://bizzabo-demo-res.cloudinary.com/image/upload/v1655404190/ring/sessionInteraction_omeahb.png',
    },
    VENUE_EVENT_MAIN_STAGE: { label: 'Expo Hall' },
    VENUE_EVENT_SIDE_PANEL: {
        label: 'Leader Board',
        icon: 'https://bizzabo-demo-res.cloudinary.com/image/upload/v1655404190/ring/leaderBoard_hbrhz0.png',
    },
    VENUE_EVENT_SIDE_PANEL_GAMIFICATION: {
        label: 'Rewards',
        icon: 'https://bizzabo-demo-res.cloudinary.com/image/upload/v1669293516/ring/reward_incently_svg1_lrgxsb.svg',
    },
};

export enum Category {
    GAMIFICATION = 'GAMIFICATION',
}

export enum ModalSize {
    sm = 'sm',
    md = 'md',
    lg = 'lg',
    xl = 'xl',
    max = 'max',
}
